var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shelter)?_c('div',{staticClass:"max-w-4xl pa-6"},[_c('div',{staticClass:"text-4xl"},[_vm._v(_vm._s(_vm.shelter.name))]),_c('div',{staticClass:"text-subtitle"},[_vm._v("Created "+_vm._s(_vm.prettyDate(_vm.shelter.date)))]),_c('shelter-list',{attrs:{"shelters":_vm.shelter.shelters}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }